import { tableReducer } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/tableReducer";

import type { IPromptsTableState, PromptsTableAction } from "./types";

export const DEFAULT_NEW_TOPIC_NAME = "New Topic";
export const NEW_PROMPT_ID_SUFFIX = "$newprompt";

export const promptsTableReducer = (state: IPromptsTableState, action: PromptsTableAction): IPromptsTableState => {
    switch (action.type) {
        case "SET_SELECTION":
            return { ...state, selectedRowKeys: action.payload };
        case "CLEAR_SELECTION":
            return { ...state, selectedRowKeys: [] };
        case "SET_FILTERS":
        case "RESET_TABLE":
            return { ...state, ...tableReducer(state, action), selectedRowKeys: [] };
        default:
            return { ...state, ...tableReducer(state, action) };
    }
};

export const INITIAL_TABLE_STATE: IPromptsTableState = {
    currentPage: 1,
    searchTerm: "",
    sorting: {
        dataIndex: "timestamp",
        sortDirection: "ascend",
    },
    filterState: {},
    selectedRowKeys: [],
};

export const TABLE_PAGE_SIZE = 100;
export const DEFAULT_MIN_PROMPTS_TO_GENERATE = 10;
export const CSV_TEMPLATE_PATH = "/images/llm-tracker/files/prompts_csv_template-UTF-8.csv";
export const ALLOWED_CSV_EXTENSIONS = ["csv"];
export const ALLOWED_CSV_MIME_TYPES = ["text/csv", "text/plain"];
export const CSV_COLUMN_ALIASES = {
    prompt: ["prompt", "prompts", "query", "queries"],
    topic: ["topic", "topics"],
};
